var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3610_20700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24252 2.01204H13.0012L9.09929 13.5798C9.07934 13.6389 9.0503 13.6945 9.01323 13.7447C8.97623 13.7948 8.93161 13.8388 8.88095 13.8752C8.8303 13.9115 8.77441 13.9398 8.71502 13.9589C8.65563 13.9779 8.5937 13.9878 8.53146 13.9878H5.60625C5.51129 13.9878 5.4176 13.9652 5.33313 13.9217C5.24856 13.8783 5.17556 13.8154 5.12019 13.7381C5.06478 13.6609 5.02854 13.5716 5.01444 13.4776C5.00031 13.3836 5.00888 13.2875 5.03921 13.1975L8.67453 2.41965C8.69438 2.36058 8.72344 2.305 8.76059 2.25482C8.79759 2.20465 8.84237 2.16066 8.89286 2.1243C8.94352 2.08794 8.99941 2.05967 9.0588 2.04062C9.11819 2.02156 9.18011 2.01172 9.24236 2.01172V2.01188L9.24252 2.01204Z",
    fill: "url(#paint0_linear_3610_20700)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1706 13.9876H12.7955C12.7579 13.9876 12.7203 13.9841 12.6831 13.977C12.6461 13.97 12.6098 13.9595 12.5747 13.9457C12.5396 13.9319 12.5059 13.9148 12.474 13.8948C12.4421 13.8746 12.4122 13.8515 12.3846 13.8258L8.5546 10.249C8.51409 10.2111 8.48588 10.162 8.47362 10.1079C8.46137 10.0539 8.46568 9.9974 8.48599 9.94582C8.50629 9.89425 8.54166 9.84999 8.58747 9.81879C8.63336 9.78767 8.68751 9.771 8.74293 9.771H14.7032L16.1703 13.9878L16.1706 13.9876Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0136 2.01221L10.3825 9.77208L14.6816 9.77113L16.1562 13.9879H12.7939C12.7591 13.9876 12.7243 13.9844 12.69 13.9783C12.6557 13.9721 12.6221 13.963 12.5894 13.9509C12.5238 13.927 12.4628 13.8921 12.409 13.8476L9.82358 11.4346L9.09981 13.5691C9.08108 13.6224 9.05535 13.6731 9.02328 13.7196C8.95899 13.8132 8.87106 13.8881 8.76842 13.9366C8.71732 13.9608 8.66323 13.9781 8.60757 13.9879H5.60693C5.51102 13.9883 5.41638 13.9654 5.33111 13.9212C5.24583 13.8771 5.17242 13.8131 5.11709 13.7347C5.06176 13.6562 5.02613 13.5656 5.01322 13.4704C5.00035 13.3753 5.01054 13.2784 5.04291 13.188L8.67235 2.42792C8.69125 2.36774 8.71967 2.31106 8.75651 2.25993C8.79319 2.2088 8.83797 2.1637 8.88878 2.12654C8.9396 2.08939 8.99613 2.06049 9.05599 2.04111C9.11585 2.02174 9.17857 2.0119 9.24161 2.01221H13.0138H13.0136Z",
    fill: "url(#paint1_linear_3610_20700)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6782 13.1976C17.7085 13.2877 17.7171 13.3837 17.7031 13.4777C17.689 13.5717 17.6528 13.661 17.5975 13.7383C17.5421 13.8155 17.4691 13.8784 17.3846 13.9218C17.3001 13.9652 17.2065 13.9879 17.1114 13.9879H12.9223C13.0172 13.9879 13.1109 13.9652 13.1955 13.9219C13.28 13.8785 13.3531 13.8155 13.4085 13.7383C13.4639 13.6611 13.5001 13.5717 13.5142 13.4777C13.5284 13.3837 13.5198 13.2877 13.4895 13.1976L9.85399 2.4195C9.81397 2.30077 9.73772 2.19759 9.63597 2.12447C9.58547 2.08811 9.52958 2.06 9.47035 2.04095C9.41112 2.02189 9.3492 2.01221 9.28711 2.01221H13.4761C13.5384 2.01221 13.6001 2.02189 13.6595 2.04095C13.7188 2.06 13.7747 2.08827 13.8253 2.12447C13.8758 2.16083 13.9204 2.20482 13.9574 2.25484C13.9944 2.30486 14.0233 2.36043 14.0433 2.4195L17.6788 13.1976H17.6782Z",
    fill: "url(#paint2_linear_3610_20700)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3610_20700",
    x1: 10.6143,
    y1: 2.89967,
    x2: 6.70808,
    y2: 14.4389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3610_20700",
    x1: 11.8311,
    y1: 8.27645,
    x2: 10.9276,
    y2: 8.58291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3610_20700",
    x1: 11.3331,
    y1: 2.56321,
    x2: 15.6204,
    y2: 13.9849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3610_20700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7173,
    height: 12,
    fill: "white",
    transform: "translate(5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureMainLogo);
export default __webpack_public_path__ + "static/media/AZURE_mainLogo.02e095321b48bd45e08a8e70b3a82432.svg";
export { ForwardRef as ReactComponent };